
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 .214a4.256 4.256 0 00-3.021 1.258L1.093.586.714 3.208l2.656-.345-.889-.888A3.551 3.551 0 015 .929 3.575 3.575 0 018.571 4.5 3.575 3.575 0 015 8.071a3.572 3.572 0 01-3.175-1.943l-.613.373A4.286 4.286 0 105 .214z","fill":"#fff"}})])
          )
        }
      }
    